export default function Footer() {
  const links = [
    { label: "Instagram", href: "https://instagram.com/thediajans" },
    { label: "Referans", href: "https://diajans.com/references" },
  ];

  return (
    <footer className="w-full bg-[#060813]  mt-10 py-6">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-gray-600 text-sm">
          {links.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="hover:text-white transition text-[#fff]"
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.label}
            </a>
          ))}
        </div>

        <p className="text-center text-xs text-gray-400 mt-4">
          © 2026 Tüm Hakları Saklıdır.
        </p>
      </div>
    </footer>
  );
}
